export default {
    props: {
        info: {
            type: Object,
            default: () => {
                return {}
            }
        },
        themeColor: {
            type: String,
            default: '#4e86ff'
        }
    },
    data() {
        return {
            searchText: '',
            isAppen: false,
            historyList: []
        }
    },
    methods: {
        search(event, name) {
            const text = name || this.searchText
            if (event.keyCode === 13 || event.keyCode === undefined) {
                const syllable = this.info.info.syllable
                let par = ''
                if (syllable.name === '自定义标题' || syllable.name === undefined) {
                    par = text
                } else {
                    par = {
                        [`${syllable.title}_${syllable.type === '' ? syllable.title : syllable.type}`]: [text]
                    }
                }
                if (text === '') {
                    par = ''
                }
                this.$emit('search-todo', par, this.info.i)
            }
        },
        init(key = 'bigsearch') {
            let list = localStorage.getItem(`history-${key}`)
            if (list) {
                list = JSON.parse(list)
                this.historyList = list
            }
            document.body.addEventListener('click', this.closeHistory)
        },
        closeHistory() {
            if (this.isAppen) {
                this.isAppen = false
            }
        },
        initHittory(h = 12) {
            const el = this.$refs.historyList
            const obj = {}
            const elInp = this.$refs.elInput
            if (elInp) {
                const pos = elInp.$el.getElementsByClassName('el-input__wrapper')[0].getBoundingClientRect()
                obj.left = `${pos.left}px`
                obj.top = `${pos.top + pos.height - h}px`
                obj.width = `${pos.width}px`
            }
            el.style.top = obj.top
            el.style.left = obj.left
            el.style.width = obj.width
        },
    },
    beforeUnmount() {
        document.body.removeEventListener('click', this.closeHistory)
    },
}